import { API } from "../api/axios";
const END_POINT = "/activities";

class ActivitiesService {
    getAll(params) {
        return API.get(END_POINT, params);
    }
   
}

export default new ActivitiesService();
